module.exports = __webpack_public_path__ + "static/media/works_react-queue-router.b9d51b3f.png";